// extracted by mini-css-extract-plugin
export default {"contentDisabled":"BaseBlockLayout_contentDisabled__RN3q5"};